export const CONCENTRATED_EO_TRADES = 'Concentrated EO Trades';
export const CONCENTRATED_EO_TRADES_SCORE = 'Risk Score';
export const OUTLIER_DETECTION_TITLE = 'Outlier Detection';
export const RM_REVENUE_VS_PORTFOLIO_PNL_RM_LEVEL_TITLE =
    'RM Revenue vs Portfolio Unrealized PnL - RM level';
export const RM_REVENUE_VS_PORTFOLIO_PNL_PORTFOLIO_LEVEL_TITLE =
    'RM Revenue vs Portfolio Unrealized PnL - Portfolio level';
export const TREND_ANALYSIS_TITLE = 'Trend Analysis';
export const EO_TRADES_TITLE = 'Execution only Trades breakdown by VC Status';
export const PEER_COMPARISON_TITLE = 'Peer Comparison';
export const RM_RISK_PROFILE_TITLE = 'RM Risk Profile - 8124';
export const RED_DIAMOND_URL =
    'image://https://gist.githubusercontent.com/eLn86/59cb970af23318eb79f388fc2adba4de/raw/58c3caa992f0f514f8d81397390b8434a23d165e/red-diamond-symbol.svg';
export const RED_DIAMOND_OP20_URL =
    'image://https://gist.githubusercontent.com/eLn86/f72bc4a04226157f0d64bb4cb4e7b9df/raw/dfa995b4e8264dcfa26d568a0fdd7b88f728b18a/red-diamond-symbol-op20.svg';
export const RED_DIAMOND_OP50_URL =
    'image://https://gist.githubusercontent.com/eLn86/5fbf09714353bde8b28fd62352e1084e/raw/db89c9ce0cd8cfdd0a999b42b04e28742c190763/red-diamond-symbol-op50.svg';
export const RED_DIAMOND_GRAPHIC_URL =
    'https://gist.githubusercontent.com/eLn86/59cb970af23318eb79f388fc2adba4de/raw/58c3caa992f0f514f8d81397390b8434a23d165e/red-diamond-symbol.svg';
export const RED_WHITE_CIRCLE_5_URL =
    'https://gist.githubusercontent.com/eLn86/fc8c575dc91f6b84d9a4ab2d70684b92/raw/f2ef256009c49f1cc6789d8207c26e984b9df51a/red-white-circle-5.svg';
export const RED_WHITE_CIRCLE_10_URL =
    'https://gist.githubusercontent.com/eLn86/e408d5ead0423d57078045acc3b82a6d/raw/7ce983f4b410ab3941853238bf280fe6aa881761/red-white-circle-10.svg';
export const RED_WHITE_CIRCLE_20_URL =
    'https://gist.githubusercontent.com/eLn86/06c510b0b09549284aeab2c8c2fbbc3a/raw/36928b37ac6cf6c57a14a4caee9ee841dbad1cd7/red-white-circle-20.svg';
export const GREY_ARROWS_IN_URL =
    'https://gist.githubusercontent.com/eLn86/2da5cb367a7b9bea6fb56be208405014/raw/00127a2b77282b5797612d6dc001b3d2209cd889/grey-arrows-in.svg';
export const GREY_ARROWS_OUT_URL =
    'https://gist.githubusercontent.com/eLn86/e706e0e5f5e9f64ef9b0730ce3c8400f/raw/c2103bac9813829ffe73ce87cd7756b404b79fe9/grey-arrows-out.svg';
export const BLACK_ARROWS_IN_URL =
    'https://gist.githubusercontent.com/eLn86/05adc6059ed39586166c975055ea1721/raw/4dc786473a6cb6fee6fb67154a9f9f4cc54969c2/black-arrows-in.svg';
export const BLACK_ARROWS_OUT_URL =
    'https://gist.githubusercontent.com/eLn86/7e8a6f998a8a29e47b01013f4ef7178f/raw/cf78ad95571b6d14dc84abe092da29c71a5076e7/black-arrows-out.svg';
export const TEAL_ARROWS_IN_URL =
    'https://gist.githubusercontent.com/eLn86/2b5e957936491988f243a5a5f91f0f02/raw/0e3616313a466b8a02565103c4fc2b0116d85645/teal-arrows-in.svg';
export const TEAL_ARROWS_OUT_URL =
    'https://gist.githubusercontent.com/eLn86/43de4464d9609401a248daeb47e518db/raw/80502855eddaa3074ade4aa9cfa0bfafe34bb808/teal-arrows-out.svg';

export const LESS_THAN_OR_EQUAL_TO_TEN_PERCENT_ABOVE_UPPER_LIMIT =
    '\u226410% above upper limit';
export const MORE_THAN_TEN_PERCENT_ABOVE_UPPER_LIMIT = '>10% above upper limit';
export const MORE_THAN_TWENTY_PERCENT_ABOVE_UPPER_LIMIT =
    '>20% above upper limit';
export const GREEN_CIRCLE_URL =
    'https://gist.githubusercontent.com/eLn86/5e407d79894fb2d4e7a67a842f9b4d9d/raw/ff79f853b9619d21281f2c63890b44e4723dd85f/green-circle.svg';
export const ORANGE_CIRCLE_URL =
    'https://gist.githubusercontent.com/eLn86/0d9c6053c717656e906f3cdb53717ca7/raw/946fccf4214bc849aa563085ea2badc17b223c02/orange-circle.svg';
export const PINK_RED_CIRCLE_URL =
    'https://gist.githubusercontent.com/eLn86/5b7bc5890df12dc5deadd00dd9bde18f/raw/d65fa40ea70f1446b9f2965667b8982f27a2b56c/pink-red-circle.svg';
export const OUTLIER_PART_TWO_BACK_ARROW_URL =
    'https://gist.githubusercontent.com/eLn86/777534e4dfcc2a7f331c0e2ab38ad322/raw/10e6172630210dfce62b8bab7b726bb5499697ab/outlier-part-two-back-arrow.svg';
export const NON_OUTLIER_RM_ICON_URL =
    'image://https://gist.githubusercontent.com/eLn86/24230f1598ff9cfca5171c38f584cfb8/raw/4c0e34535aad0020928cf10d8cef954c7417d7f7/dark-grey-diamond-icon.svg';

export const UPPER_LIMIT_TEN_PERCENT = 10;
export const UPPER_LIMIT_TWENTY_PERCENT = 20;
export const SCENARIO_ONE_TREND_Y_AXIS_AMOUNT = 'Amount ($)';
export const PERCENT_OF_EXECUTION_ONLY_TRADES = '% of Execution only Trades';
export const TOTAL_SCORE = 'Total Risk Score';
export const PERCENT_OF_ALERTS = '% of Alerts';
export const NON_OUTLIER_RM = 'Non-outlier RM';
export const OUTLIER_RM = 'Outlier RM';

export const scoreDecompositionCharts = [
    {
        score: 's1Score',
        rank: 's1Rank',
        displayValue: 'Scenario 1',
        color: '#FFA08C'
    },
    {
        score: 's2Score',
        rank: 's2Rank',
        displayValue: 'Scenario 2',
        color: '#FFB6A7'
    },
    {
        score: 's3Score',
        rank: 's3Rank',
        displayValue: 'Scenario 3',
        color: '#9BCEE2'
    },
    {
        score: 's4Score',
        rank: 's4Rank',
        displayValue: 'Scenario 4',
        color: '#549AB5'
    },
    {
        score: 'correlationScore',
        displayValue: 'Correlation',
        color: '#929292'
    }
];

export const scoreDecompositionStartPointValueMapping = {
    1: 132,
    2: 105,
    3: 78,
    4: 52,
    5: 40
};

export const noResultsText = {
    type: 'text',
    style: {
        text: 'No Results',
        fill: '#222222',
        fontFamily: 'Outfit',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '14px'
    },
    cursor: 'default',
    left: 'center',
    top: 'center'
};
